import { m } from 'framer-motion';
import React from 'react';

const Spin = (props: { children: React.ReactNode }) => {
  return (
    <m.div
      animate={{ rotate: 360 }}
      transition={{
        duration: 1.5,
        ease: 'easeOut',
        repeat: Infinity,
        repeatDelay: 0.3,
      }}
    >
      {props.children}
    </m.div>
  );
};

export default Spin;
